export const label = 'Initial portfolio';
export const fields = ['givenPortfolio'] as const;
